import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from 'reflexbox';
import { codePointSize } from '@uiw/react-codemirror';

export const Pointer = styled(Box)`
  ${({ inactive }) => !inactive ? css`
    cursor: ${props => props.hide_pointer ? 'default' : 'pointer'};
  ` : css`
    pointer-events: none;
  `}
  ${({ hoverUnderline }) =>
    hoverUnderline && css`&:hover{
      text-decoration: underline
    }`
  }
`;

export const CopyIcon = ({ fillColor = '#FFF', strockeColor="#4392E0", size=24 }) => (
  // eslint-disable-next-line no-unused-expressions
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48">
    <rect x="8" y="12" width="28" height="32" rx="2" ry="2" fill={fillColor} stroke={strockeColor} stroke-width="4" />
    <rect x="12" y="6" width="28" height="32" rx="2" ry="2" fill={fillColor} stroke={strockeColor} stroke-width="4" />
  </svg>
);